import * as THREE from 'three';

export enum CameraType {
  Perspective,
  Orthographic,
}

export enum ImageType {
  Rectilinear = 0,
  Spherical = 1,
}

export enum DirectionArrow {
  Left = 0,
  Right = 1,
  Up = 2,
  Down = 3,
}

export enum UnitSystemEnum {
  METRIC = 'Metric',
  IMPERIAL = 'Imperial',
}

export enum ViewerFileType {
  POINT_CLOUD_NODE = 0,
  VIEWER_IMAGE = 1,
}

export enum EditableObjectType {
  Cuboid,
  Model,
  // Cylinder,
  // Sphere,
  // LineSegments,
}

export enum CuboidVariants {
  LinesAndTransparentMesh,
  LinesOnly,
  LinesAndWireframeMesh,
}

export enum TransformMode {
  View,
  BoxResize,
  Translate,
  Rotate,
  Scale,
}

export enum ControlsType {
  View,
  AlignedBox,
  Transform,
}

export enum TransformControlsMode {
  Translate,
  Rotate,
  Scale,
}

export enum TransformSpace {
  Local,
  World,
}

export enum Side {
  FrontSide,
  BackSide,
  DoubleSide,
}

export const toThreeSide = (side: Side) => {
  switch (side) {
    case Side.FrontSide:
      return THREE.FrontSide;
    case Side.BackSide:
      return THREE.BackSide;
    default:
    case Side.DoubleSide:
      return THREE.DoubleSide;
  }
};
